import type { FallbackRender } from "@sentry/react";

/**
 * Minimal fallback UI rendered by Sentry.ErrorBoundary when a component
 * subtree crashes. Keeps the user in a recoverable state.
 */
export const SentryFallback: FallbackRender = ({ error, resetError }) => {
  const message = error instanceof Error ? error.message : String(error);
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4 bg-white p-8 text-slate-900 dark:bg-slate-950 dark:text-slate-100">
      <div className="max-w-md text-center">
        <h1 className="mb-2 text-2xl font-semibold">Something went wrong</h1>
        <p className="mb-4 text-sm text-slate-600 dark:text-slate-400">
          LexPortal hit an unexpected error. The team has been notified.
        </p>
        <pre className="mb-6 max-h-40 overflow-auto rounded bg-slate-100 p-3 text-left text-xs text-slate-700 dark:bg-slate-900 dark:text-slate-300">
          {message}
        </pre>
        <div className="flex justify-center gap-3">
          <button
            type="button"
            onClick={resetError}
            className="rounded bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
          >
            Try again
          </button>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="rounded border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50 dark:border-slate-700 dark:text-slate-200 dark:hover:bg-slate-900"
          >
            Reload page
          </button>
        </div>
      </div>
    </div>
  );
};
